import { AccessPermissions } from "../../modules/app/acces-rules";
import { ACCESS_PERMISSIONS } from "../actions-constants/accessPermissions.constants";

const initialAccessPermissions = new AccessPermissions();

export function AccessPermissionReducer(accessPermissions:AccessPermissions=initialAccessPermissions,action):AccessPermissions {
    switch(action.type) {
        case ACCESS_PERMISSIONS.SET_PERMISSIONS:
            return {...accessPermissions,...action.permissions}
        default:
            return accessPermissions
    }
}